<template>
  <div class="template">

    <h2 class="header">Drottningens juvelsmycke</h2>

  </div>
</template>

<script>
export default {
  name: 'DJHome',
  readable: 'Drottningens juvelsmycke',
  route: 'hem',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.border{
  border: 1px solid gray;
}

.header{
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/objects/drottningensjuvelsmycke/tabs/DJHome.vue